import * as types from '../actions/action-types';

const initialState = {
  logs: [],
  getLogsError: null,
};

const logReducer = function(state = initialState, action) {
  switch (action.type) {
    case types.GET_LOGS_KEY_CREATION_SUCCESS:
      return Object.assign({}, state, {
        logs: action.logs,
        totalPages: action.totalPages,
        totalElements: action.totalElements,
        getLogsError: null,
      });
    case types.GET_LOGS_KEY_CREATION_ERROR:
      return Object.assign({}, state, {
        logs: [],
        getLogsError: action.error,
      });
  }
  return state;
};

export default logReducer;
